import { render, staticRenderFns } from "./UserAppMenuSection.vue?vue&type=template&id=08dfaa90&scoped=true"
import script from "./UserAppMenuSection.vue?vue&type=script&lang=ts"
export * from "./UserAppMenuSection.vue?vue&type=script&lang=ts"
import style0 from "./UserAppMenuSection.vue?vue&type=style&index=0&id=08dfaa90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dfaa90",
  null
  
)

export default component.exports